export class Reveal {
    revealElement: HTMLElement;
    buttonElement: HTMLButtonElement;
    dataPanel: HTMLElement;

    constructor(revealElement: HTMLElement) {
        this.revealElement = revealElement;
        this.initElements();
        this.initListeners();
    }

    initElements = () => {
        this.buttonElement = this.revealElement.querySelector('button');
        this.dataPanel = this.revealElement.querySelector('div[data-panel]');
    }

    initListeners = () => {
        this.buttonElement.addEventListener('click', (e) => { 
            e.preventDefault();
            this.togglePanelVisibility()
            this.dataPanel.parentElement.classList.toggle('active');
        });
    }

    togglePanelVisibility = () => {
        if (this.dataPanel.classList.contains('hide')) {
            this.dataPanel.classList.remove('hide');
            return;
        }
        this.dataPanel.classList.add('hide');
    }
}